export default interface RemoteModeSettable {
  setRemoteMode(remoteMode: boolean): void;
}

export function isRemoteModeSettable(object: unknown): object is RemoteModeSettable {
  return (<RemoteModeSettable>object).setRemoteMode !== undefined;
}
